import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  pageHeader: {
    fontSize: '2xl',
    fontWeight: 'normal',
    fontFamily: 'Damion',
    textTransform: 'capitalize',
    color: 'gamma.500',
  },
  stackWrapper: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    px: ['2.5', null, null, '4'],
    py: '2',
  },
  boxWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  scrollButtonGroup: {
    variant: 'filter',
    bg: 'none',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: 'blackAlpha.400',
    borderRadius: 'none',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    pb: '3',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: '2xl',
    gap: '1',
    color: 'gamma.500',
    textTransform: 'capitalize',
    fontWeight: 'normal',
    fontFamily: 'Damion',
  },
  headingIcon: {
    color: 'gamma.500',
    sx: {},
  },
  propositionButton: {
    flex: '1',
    height: '38px',
    display: 'initial',
  },
  boxSportWrapper: {
    border: '1px',
    borderColor: 'beta.500',
    h: '100%',
  },
  buttonSport: {
    borderColor: 'beta.500',
    color: 'white',
    _active: {
      bg: 'beta.500',
      border: 'none',
      color: 'alpha.800',
      '&:after': {
        display: 'none',
      },
    },
  },
  buttonAllSports: {
    borderColor: 'beta.500',
    color: 'white',
    _active: {
      bg: 'beta.500',
      border: 'none',
      color: 'alpha.800',
      '&:after': {
        display: 'none',
      },
    },
  },
};
